import React, { useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/auth-context";
import CustomButton from "../Form/CustomButton";
import { useCart } from "../../context/cart-context";
import SignUpModal from "../../pages/auth/SignUpModal";

const BRAND = "#194049";

export const CartCheckout = () => {
  const { cart, total } = useCart();
  const { isAuthenticated } = React.useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleCheckoutRoute = () => {
    if (isAuthenticated) {
      if (total !== 0) {
        navigate("/checkout");
      } else {
        setErrorMsg("Your cart is empty.");
      }
    } else {
      setShow(true);
    }
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          p: { xs: 3, md: 3.5 },
          position: { md: "sticky" },
          top: { md: 88 },
        }}
      >
        <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#111827", mb: 2.5 }}>
          Order Summary
        </Typography>

        {errorMsg && (
          <Alert severity="error" onClose={() => setErrorMsg("")} sx={{ mb: 2, borderRadius: "8px", fontSize: 13 }}>
            {errorMsg}
          </Alert>
        )}

        {/* Line items summary */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: 13, color: "#6b7280" }}>
              Subtotal ({itemCount} item{itemCount !== 1 ? "s" : ""})
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#111827", fontWeight: 500 }}>
              £{total.toFixed(2)}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: 13, color: "#6b7280" }}>Shipping</Typography>
            <Typography sx={{ fontSize: 13, color: "#059669", fontWeight: 500 }}>Calculated at checkout</Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 2.5 }} />

        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#111827" }}>Total</Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: BRAND }}>£{total.toFixed(2)}</Typography>
        </Box>

        <CustomButton
          color="secondary"
          className="text-sm !uppercase"
          onClick={handleCheckoutRoute}
          fullWidth
          sx={{ height: 48 }}
        >
          Proceed to Checkout
        </CustomButton>

        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.75, mt: 2 }}>
          <LockOutlinedIcon sx={{ fontSize: 13, color: "#9ca3af" }} />
          <Typography sx={{ fontSize: 12, color: "#9ca3af" }}>Secure checkout</Typography>
        </Box>
      </Box>

      {show && <SignUpModal modalstate={show} handleClose={() => setShow(false)} />}
    </>
  );
};
